import Environment from './environment';

/**
 * お問い合わせ関連
 */
export default class Contact {
  constructor () {
    this.setReadOnly();
    this.subtotalCalc();
    this.totalCalc();
    this.designCheckbok();
    this.designRadio();
    this.designConsent();
  };

  /**
   * inputに読み込み専用属性を設定
   */
  setReadOnly() {
    $('.js-subtotal').attr('readonly', true);
    $('#js-total').attr('readonly', true);
  };

  /**
   * 小計計算
   */
  subtotalCalc() {
    const self = this;
    $('.js-count').change(function () {
      let elId = $(this).attr('id');
      let itemId = self.getItemId(elId);
      let price = $('#js-' + itemId + '-price').data('price');
      let count = $(this).val();
      let subtotal = price * count;
      // バリデーションを効かせるために空欄にする
      if ( subtotal == 0 ) {
        subtotal = '';
      }
      $('#js-' + itemId + '-subtotal').val(subtotal);
    });
  };

  /**
   * 合計計算
   */
  totalCalc() {
    let total = 0;
    $('.js-count').change(function () {
      total = 0;
      $('.js-subtotal').each(function (i) {
        let subtotal = $(this).val();
        subtotal = Number(subtotal);
        total += subtotal;
      });
      // バリデーションを効かせるために空欄にする
      if ( total == 0 ) {
        total = '';
      }
      $('#js-total').val(total);
    });
  };

  /**
   * 商品のID名を返す
   * @param {string} elId
   * @returns
   */
  getItemId(elId) {
    let ary = elId.split('-');
    return ary[1];
  };

  /**
   * チェックボックス デザイン付与
   */
  designCheckbok() {
    $('.c-form .c-form__checkbox input[type="checkbox"]').after('<span class="c-form__checkbox-btn"></span>');
  };

  /**
   * ラジオボタン デザイン付与
   */
  designRadio() {
    $('.c-form .c-form__radio input[type="radio"]').after('<span class="c-form__radio-btn"></span>');
  };

  /**
   * プライバシーポリシーチェック デザイン付与
   */
  designConsent() {
    const homeUrl = Environment.getHomeUrl();
    $('#js-mw-checkbox input[type="checkbox"]').after('<span class="c-form__consent-checkbox"></span>');
    $('#js-mw-checkbox .mwform-checkbox-field-text').html('<a href="' + homeUrl + 'privacy-policy/" target="_blank" rel="noopener">プライバシーポリシー</a>に同意の上、<br class="u-hidden-pc">送信ボタンを押してください。');
  };
}
